import moment from "moment";
import * as dateTimeFormatter from "date-fns";

import * as config from "util/config";
import { getLimitDate } from "util/date";

export function formatHistoricBalanceDate(dateStr) {
    if (dateStr == null || dateStr === "") {
        return "";
    }
    const raw = String(dateStr);
    const date = raw.includes("T") ? raw.substring(0, raw.indexOf("T")) : raw;
    return moment(date).format("DD/MM/YYYY");
}

export function mapHistoricBalanceToRow({ date, balance }, currencyIso, balanceLabel) {
    return {
        id: date,
        formattedDate: formatHistoricBalanceDate(date),
        currency: currencyIso,
        amount: balance,
        amountLabel: balanceLabel,
    };
}

export function buildHistoricBalancePagination(totalPages, pageNumber, onPageChange, hasRows = true) {
    if (!hasRows || totalPages == null || totalPages <= 0) {
        return undefined;
    }
    const safeTotalPages = totalPages <= 0 ? 1 : totalPages;
    return {
        totalPages: safeTotalPages,
        pageNumber,
        action: onPageChange,
        justify: "end",
    };
}

export function buildQueryMeta() {
    const now = new Date();
    return {
        date: dateTimeFormatter.format(now, config.get("frontend.shortDateFormat").toUpperCase()),
        time: dateTimeFormatter.format(now, config.get("frontend.timeFormat")),
    };
}

function getMinDateFrom() {
    const minDateFromMonths = config.getInteger("accounts.max.dateFrom", 3);
    const date = new Date();
    date.setMonth(date.getMonth() - minDateFromMonths);
    date.setHours(0, 0, 0, 0);
    return date;
}

/** @returns {{ minDate: Date, maxDate: Date, initialDateRange: [Date, Date] }} */
export function getDefaultDateRange() {
    const minDate = getMinDateFrom();
    const maxDate = getLimitDate(0).toDate();
    maxDate.setHours(23, 59, 59, 999);
    const dateTo = new Date();
    dateTo.setHours(0, 0, 0, 0);
    return {
        minDate,
        maxDate,
        initialDateRange: [minDate, dateTo],
    };
}
